const Rellax = require('./thirdparty/rellax/rellax.min');


new Rellax('.parallaximage__img,.parallax', {
  center: true
});
